module.exports = __webpack_public_path__ + "static/media/bucket.34aa0819.svg";